import { LucideLayoutPanelLeft } from "lucide-react";
import React, { useMemo } from "react";

import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";
import { LayoutMod } from "@src/store/slices/experienceBuilder/types";

export const LayoutListItem = ({ mod }: { mod: LayoutMod }) => {
  const subtitle = useSubtitle(mod);
  return (
    <ModificationListItem
      mod={mod}
      icon={<LucideLayoutPanelLeft size={16} />}
      title={"HTML modification"}
      subtitle={subtitle}
    />
  );
};

function useSubtitle(mod: LayoutMod) {
  const description = mod.description;
  const html = mod.html;

  return useMemo(() => {
    if (description) {
      return description;
    }
    if (html) {
      const el = document.createElement("div");
      el.innerHTML = html;
      return el.textContent.trim().substring(0, 100);
    }
    return "";
  }, [description, html]);
}
